import type { FacetComponentProps } from 'components/search/FacetAccordion/FacetAccordion.types';
import { Checkbox, CheckboxSubLabel } from 'components/common/CheckboxV2/Checkbox';
import { getTestId } from 'utils/testing';

export const CheckboxFacet = (props: Extract<FacetComponentProps, { type: 'checkbox' }>) => {
  const { label, count, checked, onClick, testId } = props;
  return (
    <Checkbox checked={checked} onClick={onClick} className="py-0" data-test-id={getTestId(testId)} label={label}>
      <CheckboxSubLabel className="body-xs ml-auto text-gray-700">{`(${count})`}</CheckboxSubLabel>
    </Checkbox>
  );
};
